import { createContext, useContext } from 'react';

export const JobSeekerCtx = createContext(null);

export const useJobSeekerCtx = () => useContext(JobSeekerCtx);
